import '@/assets.v2/css/style.scss'
import { initPagePdf } from '@/pages-pdf/init'

initPagePdf()
